// Lien de donation affiché dans le pied de page (Ko-fi, PayPal.Me, …).
// Laisser vide pour masquer le bloc « Soutenir Albion Helper ».
export const DONATION_URL = 'https://ko-fi.com/pierresaugues';
